import { Reducer } from 'redux';
import { UpgradeActionTypes, UpgradeState } from './types';

export const initialState: UpgradeState = {
  upgradePlanResponse: undefined,
  upgradePlanError: undefined,
  submittingUpgrade: false
};

const reducer: Reducer<UpgradeState> = (state = initialState, action: any) => {
  switch (action.type) {
    case UpgradeActionTypes.USER_PLAN_UPGRADE_START: {
      return {
        ...state,
        submittingUpgrade: true,
        upgradePlanResponse: undefined,
        upgradePlanError: undefined
      };
    }
    case UpgradeActionTypes.USER_PLAN_UPGRADE_SUCCESS: {
      return {
        ...state,
        submittingUpgrade: false,
        upgradePlanResponse: action.payload,
        upgradePlanError: undefined
      };
    }
    case UpgradeActionTypes.USER_PLAN_UPGRADE_FAILURE: {
      return {
        ...state,
        submittingUpgrade: false,
        upgradePlanResponse: undefined,
        upgradePlanError: action.payload
      };
    }
    default:
      return state;
  }
};

export default reducer;
